import { sendHitTrack } from '@plat/util/analytics'

export default {
  bind: function (el, binding, vnode) {
    const event = binding.arg

    if (!event) {
      throw Error('Event not defined.')
    }

    el.addEventListener(event, () => {
      sendHitTrack(binding.value || {})
    })
  }
}
